export default {
    baseURL:'https://i7lgyoyy8k.execute-api.ap-northeast-1.amazonaws.com/default',
    managementURL:'https://auto-avenue-ec.com:7200',
    liffid:'2006996086-eB41Xvd8',
}